var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import moment from 'moment';
import { Order, Status, Actions, LockBtn, Reorder, SecondaryLabel, Services, UserInfo } from './table-cells';
import config from '../../../../config';
import { AcceptUserAction } from './table-cells/accept-user-action';
import { getHistoryStatus } from './status-utils';
import { RestoreUserButton } from './table-cells/restore-user-button';
export var currentViewColumns = [
    {
        id: 'reorder',
        size: 24,
        minSize: 24,
        maxSize: 24,
        accessorFn: function () { return null; },
        cell: function (context) { return _jsx(Reorder, { canReorder: context.table.options.meta.reorderState.canReorder }); },
        header: function (context) { return (_jsx(LockBtn, { isLocked: context.table.options.meta.reorderState.isReorderLocked, onClick: context.table.options.meta.reorderState.toggleIsReorderLocked })); },
    },
    {
        header: '',
        cell: function (_a) {
            var getValue = _a.getValue;
            return _jsx(Order, { value: getValue() });
        },
        accessorKey: 'position',
        id: 'order',
        size: 50,
        minSize: 50,
        maxSize: 50,
    },
    {
        header: 'Clients',
        accessorKey: 'customer',
        id: 'clients',
        cell: function (cellContext) { return (_jsx(UserInfo, __assign({}, cellContext.getValue(), { searchString: cellContext.table.options.state.globalFilter }))); },
        size: 1,
        meta: {
            isFlex: true,
        },
    },
    {
        header: 'Service',
        id: 'service',
        accessorKey: 'services',
        cell: function (_a) {
            var getValue = _a.getValue;
            return _jsx(Services, { services: getValue() });
        },
        size: 1,
        meta: {
            isFlex: true,
        },
    },
    {
        header: 'Time added',
        accessorKey: 'createdAt',
        id: 'timeAdded',
        cell: function (_a) {
            var getValue = _a.getValue;
            var timeAdded = moment(getValue());
            return _jsx(SecondaryLabel, { children: timeAdded.format(config.timeFormat) });
        },
        size: 120,
        minSize: 120,
        maxSize: 120,
    },
    {
        header: 'Action',
        id: 'action',
        cell: function (cellContext) {
            var walkInItem = cellContext.row.original;
            return (_jsx(Actions, { recordId: walkInItem.id, clientName: "".concat(walkInItem.customer.firstName, " ").concat(walkInItem.customer.lastName), appointmentNote: walkInItem.appointmentNote, customerNote: walkInItem.customerNote, countdownTo: walkInItem.expiresAt }));
        },
        size: 120,
        minSize: 120,
        maxSize: 120,
    },
    {
        id: 'accept',
        cell: function (cellContext) { return _jsx(AcceptUserAction, { walkInItem: cellContext.row.original }); },
        header: '',
        size: 96,
        minSize: 96,
        maxSize: 96,
    },
];
export var historyViewColumns = [
    {
        id: 'reorder',
        cell: function () { return null; },
        header: '',
        size: 0,
        minSize: 0,
        maxSize: 0,
    },
    {
        header: 'Clients',
        accessorKey: 'customer',
        id: 'clients',
        cell: function (cellContext) { return (_jsx(UserInfo, __assign({}, cellContext.getValue(), { searchString: cellContext.table.options.state.globalFilter }))); },
        size: 1,
        meta: {
            isFlex: true,
        },
    },
    {
        header: 'Service',
        id: 'service',
        accessorKey: 'services',
        cell: function (_a) {
            var getValue = _a.getValue;
            return _jsx(Services, { services: getValue() });
        },
        size: 1,
        meta: {
            isFlex: true,
        },
    },
    {
        header: 'Time removed',
        accessorKey: 'statusUpdatedAt',
        id: 'timeRemoved',
        cell: function (_a) {
            var getValue = _a.getValue;
            return _jsx(SecondaryLabel, { children: moment(getValue()).format(config.timeFormat) });
        },
        size: 120,
        minSize: 120,
        maxSize: 120,
    },
    {
        header: 'Status',
        accessorKey: 'status',
        id: 'status',
        cell: function (cellContext) { return (_jsx(Status, { status: getHistoryStatus(cellContext.row.original.status, !!cellContext.row.original.expired) })); },
        size: 120,
        minSize: 120,
        maxSize: 120,
    },
    {
        id: 'restore',
        cell: function (cellContext) { return _jsx(RestoreUserButton, { walkInItem: cellContext.row.original }); },
        header: '',
        size: 96,
        minSize: 96,
        maxSize: 96,
    },
];
